export const setCurrentDate = (datetime) => {
    return {
        type: 'SESSION_CURRENT_DATE',
        payload: {
            datetime,
        },
    };
};

export const setSessionData = (session) => {
    return {
        type: 'SESSION_SET_DATA',
        payload: {
            session,
        },
    };
};

export const deleteSessionData = () => {
    return {
        type: 'SESSION_DELETE',
        payload: {},
    };
};

export const setSessionIp = (value) => {
    return {
        type: 'SESSION_SET_IP',
        payload: {
            value,
        },
    };
};

export const setSessionSecret = (secret) => {
    return {
        type: 'SESSION_SET_SECRET',
        payload: {
            secret,
        },
    };
};

export const setSessionSetupSecret = (flag) => {
    return {
        type: 'SESSION_SET_SETUP_SECRET',
        payload: {
            flag,
        },
    };
};
